var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// aspect-schemas/FloatAspect.ts
import { Float } from "@adornis/baseql/baseqlTypes.js";
import { Entity, Field } from "@adornis/baseql/decorators.js";
import { html } from "lit";
import { getMongoRangeFilter, renderRangePreview } from "../range-helper.js";
import { AbstractAspect } from "./AbstractAspect.js";
var FloatAspect = class extends AbstractAspect {
  constructor(doc) {
    super(doc);
  }
  getMongoFilter() {
    const { min, max, fieldName } = this;
    if (!fieldName)
      return null;
    return getMongoRangeFilter({ min, max, fieldName });
  }
};
FloatAspect._class = "FloatAspect";
__decorateClass([
  Field((type) => Float)
], FloatAspect.prototype, "min", 2);
__decorateClass([
  Field((type) => Float)
], FloatAspect.prototype, "max", 2);
FloatAspect = __decorateClass([
  Entity()
], FloatAspect);
var FloatAspectSchema = {
  aspectConstructor: FloatAspect,
  renderEditor: ({ aspectValue }) => html`
    <x-flex space="sm" horizontal>
      <x-input
        type="number"
        .value=${aspectValue.min}
        placeholder="Größer"
        @value-picked=${(e) => aspectValue.min = e.detail.value}
      ></x-input>
      <x-input
        type="number"
        .value=${aspectValue.max}
        placeholder="Kleiner"
        @value-picked=${(e) => aspectValue.max = e.detail.value}
      ></x-input>
    </x-flex>
  `,
  renderPreview: ({ aspectValue: { min, max, fieldName } }) => renderRangePreview({ min, max })
};
export {
  FloatAspect,
  FloatAspectSchema
};
